import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import type { ListPageChartsResponse } from '../list-page-charts/types';

interface UseGetAnalysesStatsParams {
	areaId?: string;
	startDate?: string;
	endDate?: string;
	enabled?: boolean;
}

export const useGetAnalysesStats = ({
	areaId,
	startDate,
	endDate,
	enabled = true,
}: UseGetAnalysesStatsParams = {}) => {
	const forBinding = useForBindingId();

	return useQuery({
		queryKey: ['analyses', 'stats', forBinding, areaId, startDate, endDate],
		enabled,
		placeholderData: (previousData, previousQuery) =>
			previousQuery?.queryKey[2] === forBinding ? previousData : undefined,
		queryFn: async () => {
			const params = new URLSearchParams();

			if (areaId) params.set('areaId', areaId);
			if (forBinding) params.set('forBinding', forBinding);
			if (startDate) params.set('startDate', startDate);
			if (endDate) params.set('endDate', endDate);

			const { data } = await api.get<ListPageChartsResponse>('/soil-analysis/stats', {
				params,
			});
			return data;
		},
	});
};
